export const ENV = {
  DEBUGGER: process.env.DEBUGGER,
  PCEK: process.env.PCEK,
  CRYPT_KEY: process.env.CRYPT_KEY,
  API_URL: process.env.API_URL,
  SOCKET_URL: process.env.SOCKET_URL,
  SITE: process.env.SITE,
}